import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { getStatus, printStatus } from '@src/util/opening';
import './styles.scss';

export default function Status({ state }) {
  return <div className={classnames('status', getStatus(state))}>{printStatus(state)}</div>;
}

Status.propTypes = {
  state: PropTypes.string.isRequired,
};
